var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#604596",
    fillOpacity: 0.88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1714_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7852 29.3156C41.6 29.0496 37.172 22.8008 30 22.8008C22.828 22.8008 18.4 29.0496 18.2148 29.3156C17.9284 29.7276 17.9284 30.274 18.2148 30.686C18.4 30.952 22.828 37.2008 30 37.2008C37.172 37.2008 41.6 30.952 41.7852 30.686C42.0716 30.274 42.0716 29.7276 41.7852 29.3156ZM30 36.0008C23.3728 36.0008 19.2 30.0008 19.2 30.0008C19.2 30.0008 23.3728 24.0008 30 24.0008C36.6272 24.0008 40.8 30.0008 40.8 30.0008C40.8 30.0008 36.6272 36.0008 30 36.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 25.1992C27.3494 25.1992 25.2002 27.348 25.2002 29.9992C25.2002 32.6504 27.349 34.7992 30.0002 34.7992C32.6514 34.7992 34.8002 32.6504 34.8002 29.9992C34.8002 27.348 32.651 25.1992 30.0002 25.1992ZM30.0002 33.5992C28.015 33.5992 26.4002 31.9844 26.4002 29.9992C26.4002 28.014 28.015 26.3992 30.0002 26.3992C31.9854 26.3992 33.6002 28.014 33.6002 29.9992C33.6002 31.9844 31.9854 33.5992 30.0002 33.5992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1714_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.dfe44535f3dd9b225e00ce6c4633bfa3.svg";
export { ForwardRef as ReactComponent };